import axios from "axios";

export default {
  actions: {
    async requestResetPassword({}, email) {
      try {
        await axios.post(
          `${process.env.VUE_APP_BASE_URL}/User/requestPassReset`,
          email
        );
      } catch (e) {
        throw e;
      }
    },

    async setNewPassword({}, payload) {
      try {
        await axios.post(
          `${process.env.VUE_APP_BASE_URL}/User/setPassword`,
          payload
        );
      } catch (e) {
        throw e;
      }
    },
  },
};
